<script setup>
import confetti from "canvas-confetti";
import Primitive from '/app/components/ui/primitive';

import { ref } from 'vue';
import { tryOnMounted, useElementVisibility, useCurrentElement, watchOnce } from "@vueuse/core";

const props = defineProps({
    options: {
        type: Object,
        default: () => ({}),
    },
    manualStart: {
        type: Boolean,
        default: false,
    },
    initialTriggers: {
        type: Array,
        default: () => [90],
    },
    delay: {
        type: Number,
        default: 500,
    },
    asChild: {
        type: Boolean,
        default: false,
    },
    as: {
        type: String,
        default: 'div',
    },
    type: {
        type: String,
        default: 'div',
    },
});

const element = useCurrentElement()
const isVisible = useElementVisibility(element);

const handleConfetti = (options) => {
    if (!element.value) return;

    const rect = element.value.getBoundingClientRect();
    const x = (rect.left + rect.width / 2);
    const y = (rect.top + rect.height / 2);

    props.initialTriggers.forEach((angle, index) => {
        setTimeout(() => {
        confetti({
            ...options,
            origin: {
                x: x / window.innerWidth,
                y: y / window.innerHeight,
            },
            get angle () {
                return angle;
            },
            });
        }, index * 500);
    });
}

watchOnce(isVisible, (visible) => {
    if (visible && !props.manualStart) {
        setTimeout(() => {
            handleConfetti(props.options);
        }, props.delay);
    }
});
</script>

<template>
     <Primitive :as="as" :type="type" :asChild="asChild" :class="$attrs.class">
         <slot :fire="handleConfetti" :is-visible="isVisible" />
     </Primitive>
</template>